import { Box } from '@material-ui/core';
import RentitemsStock from '../../../shared/RentitemsStock';

function RentItemsStockBox({ isRTL, theme, words, height }) {
  return (
    <Box>
      <RentitemsStock
        isRTL={isRTL}
        words={words}
        height={height}
        theme={theme}
        color={undefined}
      ></RentitemsStock>
    </Box>
  );
}

export default RentItemsStockBox;
